import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App as AntApp, ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import App from './App';
import { createAdminQueryClient } from './queryClient';
import './styles.css';

const AdminQueryProvider = ({ children }: { children: React.ReactNode }) => {
  const { message } = AntApp.useApp();
  const [queryClient] = useState(() => createAdminQueryClient((text) => message.error(text)));
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: {
          colorPrimary: '#1677ff',
          colorSuccess: '#18a058',
          colorWarning: '#f59e0b',
          colorError: '#ef4444',
          borderRadius: 6,
          fontSize: 14,
          colorText: '#172033',
          colorBgLayout: '#f4f6f8'
        },
        components: {
          Button: { controlHeight: 36 },
          Input: { controlHeight: 36 },
          Select: { controlHeight: 36 },
          Table: { headerBg: '#f7f8fa', headerColor: '#3b4658', cellPaddingBlock: 12 }
        }
      }}
    >
      <AntApp>
        <AdminQueryProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </AdminQueryProvider>
      </AntApp>
    </ConfigProvider>
  </React.StrictMode>
);
